import { useParams } from 'react-router-dom';
import TaskDefinitionTile from '../components/tiles/TaskDefinitionTile';
import TilesGrid from '../components/tiles/TilesGrid';
import {
  Category,
  useGetModulesWithCategoriesQuery,
  useGetTaskDefinitionsForCompanyQuery,
} from '../graphql/schema';
import { useEffect, useMemo } from 'react';

const TaskDefinitions = () => {
  const { moduleId, categoryId } = useParams();

  const { data, loading } = useGetTaskDefinitionsForCompanyQuery({
    variables: {
      moduleId: moduleId ?? '',
    },
  });

  const { data: modules } = useGetModulesWithCategoriesQuery();

  const categories = useMemo(() => {
    if (categoryId) return;

    const module = modules?.modulesWithCategories.find(
      (m) => m.id === moduleId,
    );
    if (!module) return;

    return module.categories;
  }, [modules, moduleId, categoryId]);

  useEffect(() => {
    document.getElementById('contentContainer')?.scrollTo({
      top: 0,
    });
  }, [moduleId, categoryId]);

  if (categories) {
    return categories
      .map((c) => c)
      .sort((a, b) => a.title.localeCompare(b.title))
      .map((category) => (
        <div key={category.id}>
          <div className="text-lg pl-5 mt-5 mb-[-10px]">{category.title}</div>
          <TilesGrid>
            {!loading &&
              data?.taskDefinitionsForCompany
                .filter(
                  (taskDefinition) => taskDefinition.categoryId === category.id,
                )
                .sort((a, b) => a.title.localeCompare(b.title))
                .map((taskDefinition) => (
                  <TaskDefinitionTile
                    taskDefinition={taskDefinition}
                    key={taskDefinition.id}
                  />
                ))}
          </TilesGrid>
        </div>
      ));
  }

  return (
    <>
      <TilesGrid loading={loading}>
        {!loading &&
          data?.taskDefinitionsForCompany
            .filter(
              (taskDefinition) =>
                !categoryId || taskDefinition.categoryId === categoryId,
            )
            .sort((a, b) => a.title.localeCompare(b.title))
            .map((taskDefinition) => (
              <TaskDefinitionTile
                taskDefinition={taskDefinition}
                key={taskDefinition.id}
              />
            ))}
      </TilesGrid>
    </>
  );
};

export default TaskDefinitions;
